<template>
<EsTextField
  @input="isSearching = true; search($event)"
  v-bind="$attrs"
  placeholder="Search"
  :appendIcon="isSearching ? 'mdi-loading mdi-spin' : 'mdi-magnify'"
  v-model="searchInput"
  hide-details
  clearable
  :dense="isGlobalSearch"
  :filled="isGlobalSearch" />
</template>

<script>
import { debounce } from 'lodash';
import { EsTextField } from "@86-repairs/design-system";

export default {
  name: 'EsSearch',
  components: {
    EsTextField,
  },
  props: {
    isGlobalSearch: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    searchInput: null,
    isSearching: false,
  }),
  methods: {
    search: debounce(async function search(value) {
      if (value?.length > 3) {
        this.$emit('search', { searchTerm: value, done: () => this.doneSearching() });
      } else {
        this.$emit('search', { searchTerm: null, done: () => this.doneSearching() });
      }
    }, 500),
    doneSearching() {
      this.isSearching = false;
    },
  },
};
</script>
